import { createTheme } from "@mui/material/styles";

export const switchTheme = createTheme({
    components: {
      MuiSwitch: {
        styleOverrides: {
          switchBase: {
            // Controls default (unchecked) color for the thumb
            color: "green"
          },
          colorPrimary: {
            "&.Mui-checked": {
              // Controls checked color for the thumb
              color: "blue",
              transform: "translateX(25px) !important"
            }
          },
          track: {
            // Controls default (unchecked) color for the track
            opacity: 0.7,
            backgroundColor: "lightgreen",
            ".Mui-checked.Mui-checked + &": {
              // Controls checked color for the track
              opacity: 0.7,
              backgroundColor: "lightblue"
            }
          }
        }
      }
    }
  });